// General
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Link from '../Link/Link';

// Locale
import messages from '../../locale/jsonMessages';

//Image
import footerImage from '/public/siteImages/stepFooter.svg';
import { GoBackArrow } from '../Common/Assets/SvgIconComponent/CommonSvgIcon';
//Style
import cs from '../../components/commonStyle.css';
import s from './ListPlaceStep1.css';

const SidePanel = ({ title, landingContent }) => {
	const isAdminAuthenticated = useSelector(state => state?.runtime?.isAdminAuthenticated);
	return (
		<div>
			<div className={cx(s.leftBg, 'leftBgRTL')} />
			<div className={s.titleWidth}>
				{
					!isAdminAuthenticated &&
					<Link to={'/cars'} className={cx(cs.inlineDisplayFlex,cs.alignCenter, cs.gap4, cs.commonContentText, cs.fontWeightMedium, cs.siteLinkColor, cs.textDecorationNone, cs.commonLinkBorderBottom)}>
						<GoBackArrow className={'imageRotate'}/>
						<FormattedMessage {...messages.manageAllCarsLabel} />
					</Link>
				}
				<h2 className={cx(cs.spaceBottom2, s.stepSizeCss, cs.fontWeightNormal)}>{title}</h2>
				<h3 className={cx(cs.commonTitleText, cs.fontWeightBold)}>{landingContent}</h3>
				<img src={footerImage} className={cx(s.stepFooterImage, 'stepFooterImageRTL')} />
			</div>
		</div>
	);
};

SidePanel.propTypes = {
	title: PropTypes.any,
	landingContent: PropTypes.any,
	isAdminAuthenticated: PropTypes.bool,
};

export default withStyles(cs, s)(SidePanel);